import { BanTabs } from './BanTabs'
import { withBanTabs } from './withBanTabs'

const ConnectedBanTabs = withBanTabs(BanTabs)

export { ConnectedBanTabs as BanTabs }
